import { useState } from "react";
import Toggle from "@/components/base/Toggle";
import { homeElements } from "@/mocks/services";
import type { HomeElement } from "@/mocks/services";

export default function HomeCleaningTab() {
  const [elements, setElements] = useState<HomeElement[]>(homeElements);
  const [fullEnabled, setFullEnabled] = useState(true);
  const [hourlyEnabled, setHourlyEnabled] = useState(true);
  const [hourlyPrice, setHourlyPrice] = useState("45");
  const [minHours, setMinHours] = useState("3");
  const [maxHours, setMaxHours] = useState("8");
  const [saved, setSaved] = useState(false);

  const flash = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 1500);
  };

  const toggleElement = (id: number) => {
    setElements((prev) => prev.map((e) => (e.id === id ? { ...e, enabled: !e.enabled } : e)));
    flash();
  };

  const setPrice = (id: number, val: string) => {
    setElements((prev) => prev.map((e) => (e.id === id ? { ...e, price: val } : e)));
    flash();
  };

  return (
    <div className="space-y-5">
      {/* Full cleaning */}
      <div className="rounded-[20px] bg-white p-6 shadow-card">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-ghasla-text-heading">تنظيف شامل</h2>
          <Toggle checked={fullEnabled} onChange={setFullEnabled} />
        </div>
        <div className="mt-4 overflow-x-auto">
          <table className="w-full min-w-[420px] text-sm">
            <thead>
              <tr className="text-xs font-semibold text-ghasla-text-secondary">
                <th className="h-11 px-3 text-right">العنصر</th>
                <th className="h-11 px-3 text-center">السعر (ر.س)</th>
                <th className="h-11 px-3 text-center">مفعّل</th>
              </tr>
            </thead>
            <tbody>
              {elements.map((e) => (
                <tr key={e.id} className="border-t border-[#F4F8F8]">
                  <td className="h-12 px-3 text-ghasla-text-primary">{e.name}</td>
                  <td className="h-12 px-3">
                    <div className="flex justify-center">
                      <input
                        className="h-9 w-20 rounded-lg border border-[#E4EFEF] bg-[#F0FDFD] text-center text-sm outline-none focus:border-[#0D6E6E]"
                        value={e.price}
                        onChange={(ev) => setPrice(e.id, ev.target.value)}
                      />
                    </div>
                  </td>
                  <td className="h-12 px-3">
                    <div className="flex justify-center">
                      <Toggle size="sm" checked={e.enabled} onChange={() => toggleElement(e.id)} />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Hourly */}
      <div className="rounded-[20px] bg-white p-6 shadow-card">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold text-ghasla-text-heading">عاملات بالساعة</h2>
          <Toggle checked={hourlyEnabled} onChange={setHourlyEnabled} />
        </div>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
          <div>
            <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">سعر الساعة</label>
            <div className="flex items-center gap-2">
              <input
                className="h-11 w-full rounded-[14px] border border-[#E4EFEF] bg-[#F0FDFD] px-4 text-sm outline-none focus:border-[#0D6E6E]"
                value={hourlyPrice}
                onChange={(e) => { setHourlyPrice(e.target.value); flash(); }}
              />
              <span className="text-sm text-ghasla-text-secondary">ر.س</span>
            </div>
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">الحد الأدنى للساعات</label>
            <input
              type="number"
              className="h-11 w-full rounded-[14px] border border-[#E4EFEF] bg-[#F0FDFD] px-4 text-sm outline-none focus:border-[#0D6E6E]"
              value={minHours}
              onChange={(e) => { setMinHours(e.target.value); flash(); }}
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-ghasla-text-primary">الحد الأقصى</label>
            <input
              type="number"
              className="h-11 w-full rounded-[14px] border border-[#E4EFEF] bg-[#F0FDFD] px-4 text-sm outline-none focus:border-[#0D6E6E]"
              value={maxHours}
              onChange={(e) => { setMaxHours(e.target.value); flash(); }}
            />
          </div>
        </div>
      </div>

      {saved && (
        <div className="fixed bottom-6 left-6 flex items-center gap-2 rounded-xl bg-[#E8F9F0] px-4 py-2.5 text-sm font-medium text-[#27AE60] shadow-card">
          <i className="ri-checkbox-circle-fill" />
          تم الحفظ ✓
        </div>
      )}
    </div>
  );
}